(function ($) {
	if ($('.block-main-navigation').length) {
		var win_width = $(window).width();

		var get_li_level = function (li_element) {

			let level_class_regexp = new RegExp('level\-([0-9])', 'gi');

			let level_class_regexp_result = level_class_regexp.exec(li_element.get(0).className);

			let li_level = 0;

			if (Array.isArray(level_class_regexp_result) && (typeof level_class_regexp_result[1] !== 'undefined')) {
				li_level = level_class_regexp_result[1];
			}

			return li_level;

		}

		/**
		 * Hide sub elements and remove eligible focus
		 * @param object li_element
		 */
		var show_hide_sub_nav_items = function (li_element) {
			$('> ul a, > ul button', li_element).each(function () {
				if ($(li_element).hasClass('hover')) {
					$(this).attr('aria-hidden', '').attr('tabindex', '');
				} else {
					$(this).attr('aria-hidden', 'true').attr('tabindex', '-1');
				}
			});
		}
		/**
		 * Loop through siblings on focus to clean up hover
		 * @param object li_element
		 * @param object component is the parent component
		 */
		var li_focus = function (li_element, component) {
			$(li_element).siblings().each(function () {
				$(this).removeClass('hover');
				if ($(component).hasClass('desktop')) {
					show_hide_sub_nav_items($(this));
				}
			});

			if (!$(li_element).children(".mn-link").hasClass("mega-menu-dropdown")) {
				$('body').removeClass("mega-menu-open");
				$('.mega-menu-collapse').removeClass("show");
			}

		}

		/**
		 * Hide any expanded menus in desktop view
		 * @param object component
		 */
		var blur_menu = function (component) {
			if ($(component).hasClass('desktop')) {
				$('.menu-item-has-children.hover > button', component).trigger('click');
			}
		}

		/**
		 * Open the mobile menu and setup accessibility functions
		 *
		 * @param object component
		 * @param object nav_button is the nav toggle
		 */
		var mobile_menu_open = function (component, nav_button) {
			$('body').addClass('mn-open');
			$('#content a, #content button, #content input, #content select, #content textarea, #content iframe, #content [role="button"], #content [role="listbox"],#content form, #content map, #content canvas').attr('tabindex', '-1').attr('aria-hidden', true);
			$('.level-0 > .mn-link:not(.breakpoint-disabled)', component).attr('tabindex', '').attr('aria-hidden', '');
			$('.main-nav-close.mn-link', component).attr('tabindex', '').attr('aria-hidden', '').removeClass('hidden');
			$(component).show('fast', function () {
				$(component).addClass('menu-open');
				$(component).closest('.block-main-navigation').addClass('mobile-open');
				$(nav_button).attr('aria-expanded', 'true').attr('aria-hidden', 'true').attr('tabindex', '-1');
				// Keyboard users get moved to the first nav link
				if ('object' === typeof whatInput) {
					if ('keyboard' === whatInput.ask()) {
						$('> .level-0 .mn-link:not(.breakpoint-disabled):eq(0)', component).focus();
					}
				}
			});
		}

		/**
		 * Hide menus by component visibility settings
		 * @param object component is the navigation component
		 * @param string links_to_disable by li[data-visible]
		 */
		var hide_menu_by_screen = function (component, links_to_disable, links_to_enable) {
			$(component).addClass('hidden').attr('aria-hidden', 'true');
			$('a, button', component).attr('tabindex', '-1');
			$('li[data-visible="' + links_to_disable + '"] a, li[data-visible="' + links_to_disable + '"] button', component).attr('tabindex', '-1').addClass('breakpoint-disabled');
			$('li[data-visible="' + links_to_enable + '"] a, li[data-visible="' + links_to_enable + '"] button', component).attr('tabindex', '').removeClass('breakpoint-disabled');
		}

		/**
		 * Show menus by component visibility settings
		 * @param object component is the navigation component
		 * @param string links_to_disable by li[data-visible]
		 * @param string links_to_enable by li[data-visible]
		 */
		var show_menu_by_screen = function (component, links_to_disable, links_to_enable) {
			$(component).removeClass('hidden').attr('aria-hidden', '');
			$('a, button', component).attr('tabindex', '');
			$('li[data-visible="' + links_to_enable + '"] a, li[data-visible="' + links_to_enable + '"] button', component).attr('tabindex', '').removeClass('breakpoint-disabled');
			$('li[data-visible="' + links_to_disable + '"] a, li[data-visible="' + links_to_disable + '"] button', component).attr('tabindex', '-1').addClass('breakpoint-disabled');
			$('li[data-visible="' + links_to_disable + '"] ul:not(.sub-menu) a', component).attr('tabindex', '').removeClass('breakpoint-disabled');
		}

		/**
		 * Open the mobile menu and setup accessibility functions
		 *
		 * @param object component
		 * @param object nav_button is the nav toggle
		 */

		var mobile_menu_close = function (component, close_button, is_click) {

			let parent_button = $(close_button).attr('data-parent');
			let container = $(close_button).attr('data-target');

			$('body').removeClass('mn-open');
			$('#content a, #content button, #content input, #content select, #content textarea, #content iframe, #content [role="button"], #content [role="listbox"],#content form, #content map, #content canvas').attr('tabindex', '').attr('aria-hidden', '');
			$('.mn-link', component).attr('tabindex', '-1').attr('aria-hidden', 'true');
			$('.menu-item.hover', component).removeClass('hover');
			$(close_button).addClass('disabled');
			if ($(container).hasClass('slide-left')) {
				$(container).addClass('slide-left-close');
			}
			if ($(container).hasClass('slide-right') && $(container).hasClass('mobile')) {
				$(container).addClass('slide-right-close');
			}
			// If the back button is visible, we need to click it and do the actions associated with the back button
			setTimeout(function () {
				$(container).removeClass('menu-open');
				if ($(container).hasClass('slide-left')) {
					$(container).removeClass('slide-left-close');
				}
				if ($(container).hasClass('slide-right')) {
					$(container).removeClass('slide-right-close');
				}
				$(component).removeClass('menu-open');
				$(component).hide('fast', function () {
					$(this).css({ 'display': '' });
				});
				// On click do these options. Otherwise, if the screen is being resized, we don't need to do this.
				if (is_click) {
					$(parent_button).attr('aria-expanded', 'false').attr('aria-hidden', '').attr('tabindex', '').removeClass('active');
					$(close_button).removeClass("disabled").addClass('hidden');
					$('.mn-back-wrap', component).addClass('hidden');
					// Keyboard users get moved to the original menu toggle
					if ('object' === typeof whatInput) {
						if ('keyboard' === whatInput.ask()) {
							$(parent_button).focus();
						}
					}
				}
			}, 520);
		}

		/**
		 * In case there are multiple navs on a page, loop through each component individually.
		 * @param object component
		 *
		 * @see show_hide_sub_nav_items
		 * @see li_focus
		 */
		var main_nav_events = function (component) {
			var num_links = $('.mn-link', component).length - 1;
			var last_link = $('.mn-link:eq(' + num_links + ')', component);

			// Hide the mobile nav back button and clear mobile events
			$('.mn-close-wrap', component).addClass('hidden');
			$('.main-nav-close', component).attr('aria-hidden', 'true').attr('tabindex', '-1');
			$('.menu-item-has-children > button', component).off('click').off('keydown').off('focus').off('mouseenter');
			$('.level-0 > a', component).off('focus').off('mouseenter');
			$('.level-1 > a, .level-2 > a', component).off('keyup');

			$('.menu-item-has-children > button', component).on('click', function () {

				let par_li = $(this).closest('.menu-item-has-children');

				let par_level = get_li_level(par_li);

				$(par_li).toggleClass('hover');
				$(par_li).siblings('.menu-item').each(function () {
					$(this).removeClass('hover');
					if ($(component).hasClass('desktop')) {
						show_hide_sub_nav_items($(this));
					}
				});

				if ($(component).hasClass('desktop')) {
					show_hide_sub_nav_items(par_li);
				}
			}).on('keydown', function (event) {
				let par_li = $(this).closest('.menu-item-has-children');
				if ('escape' === event.key.toLowerCase()) {
					$(par_li).removeClass('hover');
					show_hide_sub_nav_items(par_li);

					// Close all child sub-menus
					$(par_li).find('.menu-item-has-children.hover').each(function () {
						$(this).removeClass('hover');
						if ($(component).hasClass('desktop')) {
							show_hide_sub_nav_items($(this));
						}
					});

				}
			}).on('focus', function () {
				let par_li = $(this).closest('.menu-item-has-children');
				// Hide sub elements and remove eligible focus.
				li_focus(par_li, component);
			}).on('mouseenter', function () {
				let par_li = $(this).closest('.menu-item-has-children');
				$(par_li).addClass('hover');
				$(par_li).siblings('.menu-item').each(function () {
					$(this).removeClass('hover');
					if ($(component).hasClass('desktop')) {
						show_hide_sub_nav_items($(this));
					}
					if ($(this).children(".mn-link").hasClass("mega-menu-dropdown")) {
						const mega_menu_target = $(this).children(".mn-link").data("target");

						$("body").removeClass("mega-menu-open");

						$(mega_menu_target).removeClass("show");
					}
				});

				if ($(component).hasClass('desktop')) {

					show_hide_sub_nav_items(par_li);

					if ($(this).hasClass("mega-menu-dropdown")) {

						$("body").addClass("mega-menu-open");

						$($(this).data("target")).addClass("show");


					}

				}
			});
			// When non-dropdown items are focussed, we need to remove the other hover states
			$('.menu-item:not(.menu-item-has-children) > .mn-link', component).on('focus', function () {
				let par_li = $(this).closest('.menu-item');
				// Hide sub elements and remove eligible focus
				li_focus(par_li, component);
			}).on('mouseenter', function () {
				let par_li = $(this).closest('.menu-item');
				// Hide sub elements and remove eligible focus
				li_focus(par_li, component);
			});

			$('.level-1 > .mn-link, .level-2 > .mn-link', component).on('keyup', function (e) {
				let par_li = $(this).closest('.menu-item-has-children');
				if ('escape' === e.key.toLowerCase()) {
					$(par_li).removeClass('hover');
					show_hide_sub_nav_items(par_li);
					$('>button', par_li).focus();

					// Close all child sub-menus
					$(par_li).find('.menu-item-has-children.hover').each(function () {
						$(this).removeClass('hover');
						if ($(component).hasClass('desktop')) {
							show_hide_sub_nav_items($(this));
						}
					});
				}
			});

			// Hide all submenus on last link tab out
			$(last_link).on('keydown', function (event) {
				if ('tab' === event.key.toLowerCase()) {
					blur_menu(component);
				}
			});

			$('.sub-menu', component).on('mouseleave', function (event) {
				let par_li = $(this).parent('li')
				$(par_li).removeClass('hover');
				show_hide_sub_nav_items(par_li);

				// Close all child sub-menus
				$(par_li).find('.menu-item-has-children.hover').each(function () {
					$(this).removeClass('hover');
					if ($(component).hasClass('desktop')) {
						show_hide_sub_nav_items($(this));
					}
				});
			});

			$('.mega-menu-container').on("mouseleave", function (event) {
				$(this).parent().removeClass("show");
				$("body").removeClass("mega-menu-open");
			});
		}

		/**
		 * Remove desktop specific events and add mobile specific events
		 * @param object component is the main nav
		 */
		var mobile_nav_events = function (component) {
			// Clear desktop events
			var num_links = $('.mn-link', component).length - 1;
			var last_link = $('.mn-link:eq(' + num_links + ')', component);
			$('.level-0 > button', component).off('mouseenter');
			$('.level-1 > a, .level-2 > a', component).off('keyup');
			$(last_link).off('keydown');
			$('.sub-menu', component).off('mouseleave');
			$('.level-0 > button', component).off('click').off('keydown');

			$('.mn-close-wrap', component).removeClass('hidden');
			$('.main-nav-close', component).attr('aria-hidden', '').attr('tabindex', '');

			$('.menu-item.menu-item-has-children > button', component).on('click', function () {

				let par_li = $(this).closest('.menu-item');

				let par_level = get_li_level(par_li);

				$(par_li).toggleClass('hover');
				$(par_li).siblings('.menu-item').each(function () {
					$(this).removeClass('hover');
				});
				$('.level-' + par_level + ' > .mn-link', component).attr('tabindex', '-1').attr('aria-hidden', 'true');

				if ($('.mn-back-wrap', component).hasClass('hidden')) {
					$('.mn-back-wrap', component).removeClass('hidden');
				}

				let par_li_index = $('.menu-item.level-' + par_level, component).index(par_li);

				$('.main-nav-back', component).attr({
					'tabindex': '',
					'aria-hidden': '',
					'data-parent': par_li_index,
					'data-parent-lvl': par_level
				});

				$('.menu-item > .mn-link', par_li).attr('tabindex', '').attr('aria-hidden', '');
			}).on('keydown', function (event) {
				let par_li = $(this).closest('.menu-item');
				if ('escape' === event.key.toLowerCase()) {

					let par_level = get_li_level(par_li);

					$(par_li).removeClass('hover');

					$('.level-' + par_level + ' > .mn-link', component).attr('tabindex', '').attr('aria-hidden', '');
					$('.level-' + (par_level + 1) + ' .mn-link', component).attr('tabindex', '-1').attr('aria-hidden', 'true');
				}
			});

			$('.main-nav-back').on('click', function () {
				let par_li_index = $(this).attr('data-parent');
				let par_level = $(this).attr('data-parent-lvl');

				let par_li = $('.level-' + par_level + ':eq(' + par_li_index + ')', component);

				$(par_li).removeClass('hover').focus();
				console.log(par_level);
				if (par_level > 0) {

					let grand_par_li = $(par_li).closest('.menu-item.level-' + (par_level - 1), component);

					let grand_par_li_index = $('.menu-item.level-' + (par_level - 1), component).index(grand_par_li);

					$(this).attr({
						'data-parent': grand_par_li_index,
						'data-parent-lvl': (par_level - 1)
					});

				} else {

					$('.mn-back-wrap', component).addClass('hidden');
					$(this).attr('tabindex', '-1').attr('aria-hidden', 'true');

				}

				$('.level-' + par_level + ' > .mn-link', component).attr('tabindex', '').attr('aria-hidden', '');
				$('.level-' + (par_level + 1) + ' > .mn-link', component).attr('tabindex', '-1').attr('aria-hidden', 'true');
			}).on('keydown', function (e) {
				if ('escape' === e.key.toLowerCase() || 'enter' === e.key.toLowerCase()) {
					$('.level-0:eq(' + par_li + ')', component).removeClass('hover');
					$('.mn-back-wrap', component).addClass('hidden');
					$(this).attr('tabindex', '-1').attr('aria-hidden', 'true');
					$('.level-0 > .mn-link', component).attr('tabindex', '').attr('aria-hidden', '');
					$('.level-1 > .mn-link', component).attr('tabindex', '-1').attr('aria-hidden', 'true');
				}
			});

			$('.sub-menu', component).off('mouseleave');

			$(document).on('click', '.menu-item-link', function (e) {

				if (!$(e.target).is('.menu-item-link') && !$(e.target).parent().is("a")) {
					e.preventDefault();
				}

				let menu_item_href = "";

				if ($(e.target).is("a")) {

					menu_item_href = String($(e.target).attr("href"));

				} else if ($(e.target).parent().is("a")) {

					menu_item_href = String($(e.target).parent().attr("href"));

				}

				if (menu_item_href.startsWith("#") && (menu_item_href.length > 1)) {
					let menu_component = $(e.target).closest(".main-navigation-nav");
					mobile_menu_close(menu_component, menu_component.find(".main-nav-close"), true);
				}

			});
		}

		/**
		 * Initialize the menus
		 * @param object component is the navigation component
		 *
		 * @see mobile_menu_close
		 * @see main_nav_events
		 * @see show_hide_sub_nav_items
		 * @see blur_component
		 * @see mobile_nav_events
		 * @see hide_menu_by_screen
		 * @see show_menu_by_screen
		 */
		var initialize_menu = function (component) {
			let breakpoint = $(component).attr('data-breakpoint');
			let menu_visibility = $(component).attr('data-visible');
			if (isNaN(parseInt(breakpoint, 10))) {
				breakpoint = 992;
			}

			// Initialize desktop
			if (win_width >= breakpoint) {
				if (!$(component).hasClass('desktop')) {
					// Hide this menu if it's only supposed to show on small screens by breakpoint. Desktop will always be defined as >= defined breakpoint
					if ('mobile' !== menu_visibility) {
						show_menu_by_screen(component, 'mobile', 'desktop');
						if ($('body').hasClass('mn-open')) {
							mobile_menu_close(component, $('.main-nav-close', component), false);
						}
						$(component).removeClass('mobile').addClass('desktop').css("display", "");
						main_nav_events(component);
						$('.level-0', component).each(function () {
							show_hide_sub_nav_items($(this));
						});
						$(component).siblings('.main-nav-toggle').addClass('hidden').attr('aria-hidden', true).attr('tabindex', '-1');

						$(component).css({ 'opacity': '' });
					} else {
						$(component).siblings('.main-nav-toggle').addClass('hidden').attr('aria-hidden', true).attr('tabindex', '-1');
						hide_menu_by_screen(component, 'desktop', 'mobile');
					}
				} else {
					// Hide this menu if it's only supposed to show on large screens by breakpoint. Desktop will always be defined as >= defined breakpoint
					if ('mobile' === menu_visibility) {
						$(component).siblings('.main-nav-toggle').addClass('hidden').attr('aria-hidden', 'true').attr('tabindex', '-1');
						hide_menu_by_screen(component, 'desktop', 'mobile');
					} else {
						if ($(component).hasClass('hidden')) {
							$(component).siblings('.main-nav-toggle').addClass('hidden').attr('aria-hidden', 'true').attr('tabindex', '-1');
							show_menu_by_screen(component, 'mobile', 'desktop');
						}
					}
				}
			} else {
				if (!$(component).hasClass('mobile')) {
					// Hide this menu if it's only supposed to show on large screens by breakpoint. Desktop will always be defined as >= defined breakpoint
					if ('desktop' !== menu_visibility) {
						show_menu_by_screen(component, 'desktop', 'mobile');
						$(component).removeClass('desktop').addClass('mobile').hide();
						// Remove desktop specific options
						blur_menu(component);
						mobile_nav_events(component);
						$(component).siblings('.main-nav-toggle').removeClass('hidden').attr('aria-hidden', '').attr('tabindex', '');

						$(component).css({ 'opacity': '' });
					} else {
						$(component).siblings('.main-nav-toggle').addClass('hidden').attr('aria-hidden', 'true').attr('tabindex', '-1');
						hide_menu_by_screen(component, 'mobile', 'desktop');
					}
				} else {
					// Hide this menu if it's only supposed to show on large screens by breakpoint. Desktop will always be defined as >= defined breakpoint
					if ('desktop' === menu_visibility) {
						$(component).siblings('.main-nav-toggle').addClass('hidden').attr('aria-hidden', 'true').attr('tabindex', '-1');
						hide_menu_by_screen(component, 'mobile', 'desktop');
					} else {
						if ($(component).hasClass('hidden')) {
							$(component).siblings('.main-nav-toggle').removeClass('hidden').attr('aria-hidden', '').attr('tabindex', '');
							show_menu_by_screen(component, 'desktop', 'menu');
						}
					}
				}
			}
		}

		$(document).on('ready', function () {
			$('.main-navigation-nav').each(function () {
				let component = $(this);
				initialize_menu(component);
			});

			$(window).on('resize', function () {
				if (win_width !== $(window).width()) {
					win_width = $(window).width();
					$('.main-navigation-nav').each(function () {
						let component = $(this);
						if ($('body').hasClass('mn-open')) {
							setTimeout(function () {
								$('.main-nav-close.active').trigger('click');
							}, 250);
						}
						initialize_menu(component);
					});
				}

			});
			$(this).on('click', function (event) {
				if (!$(event.target.parentNode).is('.level-0')) {
					$('.main-navigation-nav').each(function () {
						if ($(this).hasClass('desktop')) {
							$('.level-0.hover > button', this).each(function () {
								$(this).trigger('click');
							});
						}
					});
				}
			}).on('keyup', function (e) {
				if ('escape' === e.key.toLowerCase() && $('body').hasClass('mn-open')) {
					$('.main-nav-close.active').trigger('click');
				}
			});
		});

		if ($('.main-nav-toggle').length) {
			$('.main-nav-toggle').each(function (e) {
				const nav_target = $(this).attr('data-target');
				let breakpoint = $(nav_target).attr('data-breakpoint');
				$(this).on('click', function () {
					$(this).addClass('active');
					mobile_menu_open(nav_target, $(this));
				});
			});
			$('.main-nav-close').each(function (e) {
				const nav_target = $(this).attr('data-target');
				let breakpoint = $(nav_target).attr('data-breakpoint');
				$(this).on('click', function () {
					mobile_menu_close(nav_target, $(this), true);
				});
			});
		}
	}
}(jQuery));